import React, { useState } from 'react'
import PropTypes from 'prop-types'
import tw, { css, styled } from 'twin.macro'

import Layout from '../../components/layout'
import Meta from '../../components/meta'
import { graphql } from 'gatsby'
import axios from 'axios'
import qs from 'qs'
import filterLocale from '../../components/utils/filter-locale'
import SupportSearch from '../../components/support/support-search'
import Branch from '../../components/support/branch'
import Tabs from '../../components/support/tabs'
import {
	StyledForm,
	HomeButtonRow,
	HomeButton,
	FieldRow,
	FieldWrap,
	Required,
	StyledError,
} from '../../components/form/styles'
import { Formik } from 'formik'
import assign from 'lodash.assign'
import {
	flat,
	validationSwitch,
	validationSchema,
} from '../../components/form/utils'
import FormFieldGroup from '../../components/form/FormFieldGroup'
import FormFieldSingle from '../../components/form/FormFieldSingle'
import { animated, useTransition, useSpring } from 'react-spring'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import '@reach/dialog/styles.css'
import { XCircle } from 'react-feather'
import useWindowResize from '../../hooks/useWindowResize'
import PopUp from '../../components/modal/forms'
import { Lottie } from '@lottie'
import { Field } from 'formik'
import { CustomCheckboxContainer, CustomCheckboxInput } from '@reach/checkbox'
import * as animationCheckbox from '../../animations/checkbox.json'

const ContentsSection = tw.section`w-full bg-gray-200`
const ContentsContainer = tw.div`w-95 md:w-11/12 bg-white py-10 px-4 md:px-10 mx-auto border-l border-r border-gray-300 border-b rounded-b-lg mb-16`

const ContactContainer = tw.div`flex flex-col items-center justify-center`
const ContactTitle = tw.h3`font-display text-5xl md:text-6xl text-gray-700 font-bold text-center mb-3 md:mb-0`
const ContactDescription = tw.p`font-display text-lg mb-6 md:mb-12 text-gray-700 text-center`

const BranchContainer = tw.div`flex flex-col w-full mb-16`
const MainBranchContainer = styled.div`
	${tw`flex flex-col w-11/12 lg:w-8/12 mx-auto relative`}
`
const MainBranchImage = styled.div`
	${tw`bg-cover bg-center bg-no-repeat cursor-pointer w-full`}

	max-height: 300px;
	min-height: 300px;
	height: 100%;

	@media (min-width: 1400px) {
		max-height: 400px;
		min-height: 400px;
	}
`
const MainBranchDetails = styled.div`
	transition: all 0.2s linear;
	${tw`w-full my-6 flex flex-col justify-center`}

	> p {
		${tw`font-display`}

		> a {
			${tw`underline text-blue-500 hover:no-underline`}
		}

		> button {
			${tw`bg-yellow-500 p-2 hover:bg-yellow-400 rounded text-white hover:text-black text-sm uppercase`}
		}
	}

	> p:not(:last-of-type) {
		${tw`mb-2`}
	}
`
const AnimatedBranchDetails = animated(MainBranchDetails)
const DialogContents = styled(DialogContent)`
	${tw`relative`}

	&[data-reach-dialog-content] {
		${tw`w-11/12 md:w-10/12 p-4`}
	}
`
const TableHolder = tw.div`overflow-auto mb-12`
const StaffDetailsContainer = styled.table`
	${tw`w-full table-auto mt-4`}

	> tr > th {
		${tw`font-display border px-4 py-2 w-1/5`}
	}
	> tr > td {
		min-width: 200px;
		${tw`font-display border px-1 sm:px-4 py-2 text-center`}

		> a {
			${tw`underline text-blue-500 hover:no-underline`}
		}
	}
`
const BranchName = tw.h3`font-display text-lg font-bold`
const CloseButton = styled(XCircle)`
	${tw`cursor-pointer ml-auto absolute`}
	right: 1rem;
	top: 1rem;
`
const Close = styled.button`
	${tw`font-display bg-yellow-500 hover:bg-yellow-400 p-2 rounded uppercase absolute`}
	right: 1rem;
	bottom: 1rem;
`
const ImageHolder = styled.div`
	${tw`relative cursor-pointer`}
`
const ImageOverLay = styled.a`
	content: '';
	transition: all 0.3s ease-in-out;
	background-color: rgba(55, 65, 79, 0.45);
	${tw`absolute w-full h-full left-0 right-0 top-0 bottom-0 opacity-0 hover:opacity-100 cursor-pointer flex items-center justify-center font-display text-white font-bold`}
`
const OtherBranchContainer = tw.div`w-full flex flex-row flex-wrap`
const CheckboxContainer = styled(CustomCheckboxContainer)`
	${tw`flex items-center justify-center`}
	input {
		${tw`border-0 p-0 h-px w-px -m-px absolute overflow-hidden whitespace-nowrap `}
		clip: rect(0 0 0 0);
		clippath: inset(50%);
	}
`

const renderSupportContacts = data => {
	return data.map((item, index) => {
		return (
			<div key={index}>
				<p css={[tw` my-2`]}>
					<strong>{item.label} </strong>
				</p>
				<ul>
					{item.number.map((x, i) => {
						return (
							<li
								css={[
									'list-style: none !important; padding-left: 20px; padding-bottom: 0.5rem',
								]}
								key={i}
							>
								{x.type ? <span>{x.type} - </span> : ''}
								<span>{x.label}: </span>
								<a className="phone" href={`tel:${x.value}`}>
									{x.value}
								</a>{' '}
								(select option {x.option})
							</li>
						)
					})}
				</ul>
			</div>
		)
	})
}

const Contact = ({ data: { supportcontact, contact, branch }, ...props }) => {
	const hs = props.location.hash
	const hash = hs.length && hs[0] == '#' ? hs.replace(/^#/, '') : ''
	const ps = props.location.search
	const params =
		ps.length && ps[0] == '?' ? qs.parse(ps.replace(/^\?/, '')) : ''
	const [showPopUp, setShowPopUp] = React.useState(false)
	const openPopUp = () => setShowPopUp(true)
	const closePopUp = () => setShowPopUp(false)
	const locale = 'en-AU'
	const [{ node }] = filterLocale(supportcontact.edges, locale)
	const { seoTitle, seoKeywords, seoDescription } = node

	const [{ node: nodeContact }] = filterLocale(contact.edges, locale)
	const {
		title: contactTitle,
		description: contactDescription,
		items: contactItems,
	} = nodeContact

	const valuesMapped = flat(contactItems).map(item => ({
		[item.inputName]: item.inputName === 'subject' ? params.subject : '',
	}))
	valuesMapped.push({ readandagree: false })
	const validationMapped = flat(contactItems).map(item => ({
		[item.inputName]: validationSwitch(item.inputName, item.validationText),
	}))
	validationMapped.push({ readandagree: validationSwitch('readandagree') })
	/** New Object from mapped Array */
	const valuesObject = assign({}, ...valuesMapped)
	const validationObject = assign({}, ...validationMapped)
	// const [sendForm, { loading, error, data }] = useMutation(SEND_FORM)

	const filterArrayByLocale = (items, locale) => {
		return items.filter(x => {
			return x.node.node_locale === locale
		})
	}

	const branchdetails = filterArrayByLocale(branch.edges, locale)

	const [first, ...rest] = branchdetails

	const supportContacts = [
		{
			label: 'Customer Support',
			number: [
				{
					type: 'General Enquiries',
					label: 'Customer Care',
					value: first.node.phoneNumber ?? null,
					option: 2,
				},
				{
					type: 'Technical Enquiries',
					label: 'Tech Support',
					value: first.node.phoneNumber ?? null,
					option: 2,
				},
			],
		},
		{
			label: 'Dealer Support',
			number: [
				{
					type: null,
					label: 'Customer Service',
					value: first.node.phoneNumber ?? null,
					option: 1,
				},
				{
					type: null,
					label: 'Tech Support',
					value: first.node.phoneNumber ?? null,
					option: 2,
				},
				{
					type: null,
					label: 'Account Receivable',
					value: first.node.phoneNumber ?? null,
					option: 3,
				},
			],
		},
	]

	const [open, setOpen] = useState(true)

	const spring = useSpring({
		from: {
			height: 0,
			opacity: 0,
			transform: 'translate3d(0,-15px,0)',
			overflow: 'hidden',
		},
		to: {
			height: open ? 'auto' : 0,
			opacity: open ? 1 : 0,
			transform: `translate3d(0,0,0)`,
		},
		reset: false,
	})

	const AnimatedDialogOverlay = animated(DialogOverlay)
	const AnimatedDialogContent = animated(DialogContents)
	const [showDialog, setShowDialog] = useState(false)
	const transitions = useTransition(showDialog, null, {
		from: { opacity: 0, y: -10 },
		enter: { opacity: 1, y: 0 },
		leave: { opacity: 0, y: 10 },
	})

	const { width } = useWindowResize()
	const linkAddress = first.node.branchAddress.split(' ').join('+')
	return (
		<Layout>
			<Meta
				title={seoTitle}
				keywords={seoKeywords}
				description={seoDescription}
			/>
			<SupportSearch />
			<Tabs locale={locale} />
			<ContentsSection id="contact-form">
				<ContentsContainer>
					<ContactContainer>
						<ContactTitle>{contactTitle}</ContactTitle>
						<ContactDescription css={['text-wrap: balance !important']}>
							{contactDescription}
						</ContactDescription>
						<Formik
							initialValues={valuesObject}
							validationSchema={validationSchema(validationObject)}
							onSubmit={async (values, { setSubmitting, resetForm }) => {
								setSubmitting(true)
								const url =
									'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
								const body = {
									origin: 'Contact Us WebSite',
									orgid: '00D58000000JkgU',
									retURL:
										'https://maytronics.com.au/support/contact/?form=contact',
									'00N4H00000E2wq9':
										'https://maytronics.com.au/support/contact',
									name: values.name,
									subject: values.subject,
									email: values.email,
									phone: values.phone,
									'00N5800000Du5Hs': values.serialNo,
									description: values.message,
									recordType: '0124H0000006NyI', // Contact Us
								}
								axios.post(url, qs.stringify(body))
								// axios.post('/.netlify/functions/graphql', {
								// 	query: `
								// 		mutation createForm(
								// 			$formName: String!
								// 			$subject: String
								// 			$name: String
								// 			$email: String
								// 			$phone: String
								// 			$serialNo: String
								// 			$message: String
								// 		) {
								// 			createForm(
								// 				formName: $formName
								// 				subject: $subject
								// 				name: $name
								// 				email: $email
								// 				phone: $phone
								// 				serialNo: $serialNo
								// 				message: $message
								// 			) {
								// 				_id
								// 				formName
								// 				subject
								// 				name
								// 				email
								// 				message
								// 			}
								// 		}
								// 	`,
								// 	variables: {
								// 		formName: 'contact-us',
								// 		...values,
								// 	},
								// })
								resetForm()
								setSubmitting(false)
								return openPopUp()
							}}
						>
							{({ isSubmitting, errors, touched, values }) => (
								<StyledForm>
									{contactItems.map((item, index) => {
										if (item.items) {
											const { title, items } = item
											return (
												<FormFieldGroup
													key={title + index}
													// color="#fff"
													{...{ items, errors, touched, values }}
												/>
											)
										} else {
											return (
												<FormFieldSingle
													key={item.inputName + index}
													overrideWidth="full"
													// color="#fff"
													{...{
														item: { ...item, helpText: null },
														errors,
														touched,
														values,
													}}
												/>
											)
										}
									})}
									<FieldRow>
										<FieldWrap>
											<Field name="readandagree" type="checkbox">
												{({ field, form: { setFieldValue, setTouched } }) => (
													<div tw="flex w-full mb-4 items-center">
														<CheckboxContainer
															tw="w-6 h-6 cursor-pointer rounded-sm mr-2"
															onClick={() =>
																setFieldValue(
																	'readandagree',
																	field.checked ? false : true
																)
															}
															onKeyDown={() =>
																setFieldValue(
																	'readandagree',
																	field.checked ? false : true
																)
															}
														>
															<CustomCheckboxInput
																{...field}
																checked={field.checked}
																name="readandagree"
																type="checkbox"
															/>
															<Lottie
																playingState={'playing'}
																speed={1}
																direction={field.checked ? 1 : -1}
																width={24}
																height={24}
																tw="bg-white rounded"
																className="lottie-container checkbox"
																config={{
																	animationData: animationCheckbox.default,
																	loop: false,
																	autoplay: true,
																	renderer: 'svg',
																}}
																aria-hidden
															/>
														</CheckboxContainer>
														<p tw="text-sm font-display">
															I have read and I agree to{' '}
															<a
																tw="font-bold underline hover:no-underline"
																href="/terms"
																target="_blank"
															>
																Maytronics Terms &#38; Conditions
															</a>{' '}
															and{' '}
															<a
																tw="font-bold underline hover:no-underline"
																href="/privacy"
																target="_blank"
															>
																Privacy Policy
															</a>{' '}
															<Required>*</Required>
														</p>
													</div>
												)}
											</Field>
											{touched['readandagree'] && errors['readandagree'] ? (
												<StyledError>
													{`▲ ` + errors['readandagree']}
												</StyledError>
											) : (
												<></>
											)}
										</FieldWrap>
									</FieldRow>
									<FieldRow>
										<FieldWrap>
											<Field name="updates" type="checkbox">
												{({ field, form: { setFieldValue, setTouched } }) => (
													<div tw="flex w-full mb-4 items-center">
														<CheckboxContainer
															tw="w-6 h-6 cursor-pointer rounded-sm mr-2"
															onClick={() =>
																setFieldValue(
																	'updates',
																	field.checked ? false : true
																)
															}
															onKeyDown={() =>
																setFieldValue(
																	'updates',
																	field.checked ? false : true
																)
															}
														>
															<CustomCheckboxInput
																{...field}
																checked={field.checked}
																name="updates"
																type="checkbox"
															/>
															<Lottie
																playingState={'playing'}
																speed={1}
																direction={field.checked ? 1 : -1}
																width={24}
																height={24}
																tw="bg-white rounded"
																className="lottie-container checkbox"
																config={{
																	animationData: animationCheckbox.default,
																	loop: false,
																	autoplay: true,
																	renderer: 'svg',
																}}
																aria-hidden
															/>
														</CheckboxContainer>
														<p tw="text-sm font-display">
															I wish to receive updates and promotions from
															Maytronics.
														</p>
													</div>
												)}
											</Field>
										</FieldWrap>
									</FieldRow>
									<HomeButtonRow>
										<HomeButton type="submit" disabled={isSubmitting}>
											{isSubmitting ? 'Sending...' : 'Send Message'}
										</HomeButton>
									</HomeButtonRow>
								</StyledForm>
							)}
						</Formik>
						<PopUp showDialog={showPopUp} close={closePopUp} />
						<BranchContainer>
							<MainBranchContainer>
								<ImageHolder>
									<a
										href={`https://www.google.com/maps/place/${linkAddress}/`}
										target="_blank"
										rel="noopener noreferrer"
									>
										<MainBranchImage
											css={{
												backgroundImage: `url(${
													first.node.branchImage != null
														? first.node.branchImage.fluid.src
														: first.node.staticMapUrl.staticMapUrl
												})`,
											}}
										/>
									</a>
									{width > 767 ? (
										<ImageOverLay
											href={`https://www.google.com/maps/place/${linkAddress}/`}
											rel="noopener noreferrer"
											target="_blank"
										>
											<p>{first.node.branchName}</p>
										</ImageOverLay>
									) : (
										''
									)}
								</ImageHolder>
								<AnimatedBranchDetails
									className={open ? 'active' : 'notactive'}
									style={spring}
								>
									{first.node.branchName ? (
										<p>
											<strong>Head Office:</strong> {first.node.branchName}
										</p>
									) : (
										''
									)}
									{first.node.branchAddress ? (
										<p>
											<strong>Address:</strong> {first.node.branchAddress}
										</p>
									) : (
										''
									)}
									{first.node.phoneNumber ? (
										<p>
											<strong>Phone Number: </strong>
											<a
												className="phone"
												href={`tel:${first.node.phoneNumber
													.split(' ')
													.join('')}`}
											>
												{first.node.phoneNumber}
											</a>
										</p>
									) : (
										''
									)}
									{first.node.email ? (
										<p>
											<strong>Email:</strong>{' '}
											<a className="email" href={`mailto:${first.node.email}`}>
												{first.node.email}
											</a>
										</p>
									) : (
										''
									)}
									{renderSupportContacts(supportContacts)}
									<p>
										<button onClick={() => setShowDialog(true)}>
											Show Head Office Contacts
										</button>
									</p>
									{transitions.map(
										({ item, key, props: styles }) =>
											item && (
												<AnimatedDialogOverlay
													key={key}
													onClick={() => setShowDialog(false)}
													css={{ opacity: styles.opacity }}
												>
													<AnimatedDialogContent
														css={{
															transform: styles.y.interpolate(
																value => `translate3d(0px, ${value}px, 0px)`
															),
															border: '1px solid hsla(0, 0%, 0%, 0.5)',
															borderRadius: 10,
														}}
													>
														<BranchName>
															{first.node.branchName} Staff
														</BranchName>
														<CloseButton onClick={() => setShowDialog(false)} />
														<TableHolder>
															<StaffDetailsContainer>
																<tr>
																	<th>Name</th>
																	<th>Position</th>
																	<th>Mobile</th>
																	<th>LandLine</th>
																	<th>Email</th>
																</tr>
																{first.node.branchStaff.map(x => {
																	return (
																		<tr key={x.name}>
																			<td>{x.name ? x.name : ''}</td>
																			<td>{x.position ? x.position : ''}</td>
																			<td>
																				{x.mobileNumber ? (
																					<a
																						className="phone"
																						href={`tel:${x.mobileNumber
																							.split(' ')
																							.join('')}`}
																					>
																						{x.mobileNumber}
																					</a>
																				) : (
																					''
																				)}
																			</td>
																			<td>
																				{x.landlineNumber ? (
																					<a
																						className="phone"
																						href={`tel:${x.landlineNumber
																							.split(' ')
																							.join('')}`}
																					>
																						{x.landlineNumber}
																					</a>
																				) : (
																					''
																				)}
																			</td>
																			<td>
																				{x.email ? (
																					<a
																						className="email"
																						href={`mailto:${x.email}`}
																					>
																						{x.email}
																					</a>
																				) : (
																					''
																				)}
																			</td>
																		</tr>
																	)
																})}
															</StaffDetailsContainer>
														</TableHolder>
														<Close onClick={() => setShowDialog(false)}>
															Close
														</Close>
													</AnimatedDialogContent>
												</AnimatedDialogOverlay>
											)
									)}
								</AnimatedBranchDetails>
							</MainBranchContainer>

							<OtherBranchContainer>
								{rest.map((x, i) => {
									return <Branch key={i} details={x} />
								})}
							</OtherBranchContainer>
						</BranchContainer>
					</ContactContainer>
				</ContentsContainer>
			</ContentsSection>
		</Layout>
	)
}

export const supportFaqQuery = graphql`
	query suppContactQuery {
		supportcontact: allContentfulPage(
			filter: { contentful_id: { eq: "2m8O4bbpRZm15Q97CtVGu" } }
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
				}
			}
		}
		contact: allContentfulForm(
			filter: { contentful_id: { eq: "6D1VD5gGdEys2GwRQKDpWf" } }
		) {
			edges {
				node {
					title
					description
					endpoint
					node_locale
					items {
						... on ContentfulFormField {
							helpText
							inputAutocomplete
							inputId
							inputName
							inputPlaceholder
							inputRequired
							inputType
							textareaCols
							textareaRows
							icon
							validationText
							width
							options
							node_locale
							label
						}
						... on ContentfulFormGroup {
							title
							items {
								width
								validationText
								textareaRows
								textareaCols
								options
								node_locale
								label
								inputType
								inputRequired
								inputPlaceholder
								inputName
								inputId
								inputAutocomplete
								icon
								helpText
							}
						}
					}
				}
			}
		}
		branch: allContentfulBranch(
			filter: {
				country: {
					in: [
						"Australia"
						"New Zealand"
						"Philippines"
						"Singapore"
						"South Africa"
					]
				}
			}
			sort: { order: ASC, fields: order }
		) {
			edges {
				node {
					branchName
					branchAddress
					email
					phoneNumber
					node_locale
					branchStaff {
						name
						position
						mobileNumber
						landlineNumber
						email
					}
					staticMapUrl {
						staticMapUrl
					}
					branchImage {
						fluid(
							maxWidth: 800
							maxHeight: 400
							quality: 80
							cropFocus: CENTER
							resizingBehavior: FILL
						) {
							src
							srcWebp
						}
					}
				}
			}
		}
	}
`
Contact.propTypes = {
	data: PropTypes.objectOf({
		supportcontact: PropTypes.any,
		contact: PropTypes.any,
		branch: PropTypes.any,
	}),
	location: PropTypes.object,
}
export default Contact
